import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import z from "zod";

import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { useSettingsStore } from "@/shared/stores";

export const useLanguageFromParams = () => {
  const [searchParams] = useSearchParams();
  const { language: storedLanguage, setLanguage } = useSettingsStore(
    (state) => state,
  );

  const paramLanguage = z
    .enum(AVAILABLE_LANGUAGE)
    .safeParse(searchParams.get("lang")).data;

  useEffect(() => {
    setLanguage(paramLanguage ?? storedLanguage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
